module.exports = __webpack_public_path__ + "static/media/img_panel_PP.d67e079e.jpg";